import React from "react";
import { ProductChangeCandidate } from "../../interfaces/sales";

export interface ProductChangeSelectionStepProps {
  candidates: ProductChangeCandidate[];
  selectedProducts: string[];
  onToggleProduct: (uuidSaleProduct: string) => void;
}

/**
 * YOSHI-10261: paso 1 del cambio de producto. Lista los productos ya registrados que se pueden
 * cambiar y permite seleccionar uno o varios. Un producto sin opciones válidas (no hay otro producto
 * de la misma concesión al mismo precio exacto) se muestra deshabilitado con el motivo.
 */
export const ProductChangeSelectionStep: React.FC<
  ProductChangeSelectionStepProps
> = ({ candidates, selectedProducts, onToggleProduct }) => {
  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-600">
        Selecciona los productos que se marcaron por error. El reemplazo debe
        ser de la misma concesión y del mismo precio, por lo que el cobro no
        cambia.
      </p>
      <div className="max-h-80 space-y-2 overflow-y-auto pr-1">
        {candidates.map((candidate) => {
          const isSelected: boolean = selectedProducts.includes(
            candidate.uuid_sale_product,
          );
          const hasOptions: boolean = candidate.options.length > 0;

          return (
            <button
              key={candidate.uuid_sale_product}
              type="button"
              disabled={!hasOptions}
              onClick={() => onToggleProduct(candidate.uuid_sale_product)}
              className={`flex w-full items-center justify-between rounded-lg border p-3 text-left transition-colors duration-300 disabled:cursor-not-allowed disabled:opacity-60 ${
                isSelected
                  ? "border-indigo-200 bg-indigo-50"
                  : "border-gray-200 bg-white hover:bg-gray-50"
              }`}
            >
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-gray-900">
                  {candidate.product} × {candidate.quantity}
                </p>
                <p className="text-xs text-gray-500">
                  ${candidate.price.toFixed(2)} · {candidate.name_concession}
                </p>
                {!hasOptions && (
                  <p className="mt-1 text-xs text-amber-600">
                    Sin productos de reemplazo de la misma concesión y del mismo
                    precio
                  </p>
                )}
              </div>
              <span
                className={`ml-3 flex h-5 w-5 shrink-0 items-center justify-center rounded border ${
                  isSelected
                    ? "border-indigo-600 bg-indigo-600"
                    : "border-gray-300 bg-white"
                }`}
              >
                {isSelected && (
                  <span className="text-[11px] font-bold text-white">✓</span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
